import { render, staticRenderFns } from "./NewShipmentOnTms.vue?vue&type=template&id=33ca5625"
import script from "./NewShipmentOnTms.vue?vue&type=script&lang=js"
export * from "./NewShipmentOnTms.vue?vue&type=script&lang=js"
import style0 from "./NewShipmentOnTms.vue?vue&type=style&index=0&id=33ca5625&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports